
<div id="filter-options" class="flex-row gap-10">
    <div class="filter flex-1">
        <div class="filter-section-header">
            <div class="refinement-wrapper">
                <label for="file_type">Filter your files</label>
                <div *ngIf="active_filter_types && active_filter_types.length > 0"
                     class="clear-refinement text-color-primary" 
                     (click)="clearTypeFilter()">
                    Clear
                </div>
            </div>

            <input id="type-filter-refinement" 
                type="text" 
                placeholder="Type or category name..." 
                [(ngModel)]="search_document_type"
                (keyup)="refineTypeSelection()">
        </div>
        
        <div class="categories-container">
            <div *ngFor="let category of filtered_types | keyvalue" class="category-section">
                <div class="category-header">{{category.key}}</div>
                <ul>
                    <li *ngFor="let type of category.value"
                        [class.selected]="isActiveType(type.TYPE_ID)"
                        (click)="onDocumentTypeSelect(type.TYPE_ID)">
                        {{type.TYPE_NAME}}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>

